import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  Icon,
  IconButton,
  Tooltip,
} from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';
import HelpeModal from '../../../HelpeModal';
import css from '../styles.css';

const propTypes = {
  children: PropTypes.node,
  index: PropTypes.number,
  fieldName: PropTypes.string,
  onRemove: PropTypes.func,
  fieldData: PropTypes.object,
  closedByDefault: PropTypes.bool,
  label: PropTypes.string,
  dragHandleProps: PropTypes.object,
  separator: PropTypes.bool,
  open: PropTypes.bool,
  onToggle: PropTypes.func,
};

function FieldAccordion({
  children,
  label,
  index,
  fieldName,
  onRemove,
  fieldData,
  dragHandleProps,
  closedByDefault = false,
  separator = true,
  open,
  onToggle,
}) {
  const intl = useIntl();

  const fieldLabel = (
    <>
      {label ||
        fieldData.label.find((locale) => locale.locale === intl.locale)?.value}
    </>
  );

  const renderAccordionHeader = () => {
    return (
      <>
        {onRemove && (
          <IconButton
            icon="trash"
            onClick={onRemove}
            onMouseDown={(e) => e.preventDefault()}
          />
        )}
        <HelpeModal
          fieldData={fieldData}
          title={fieldLabel}
          iconSize="medium"
        />
        <div className={css.dragBtn} {...dragHandleProps}>
          <Tooltip
            id="fields-builder-change-field-order-tooltip"
            text={
              <FormattedMessage
                id="ui-plugin-inventory-templates.templateFields.builder.dragField.tooltip.msg"
                defaultMessage="Change field order"
              />
            }
          >
            {({ ref, ariaIds }) => (
              <Icon icon="drag-drop" aria-labelledby={ariaIds.text} ref={ref} />
            )}
          </Tooltip>
        </div>
      </>
    );
  };

  return (
    <Accordion
      id={`${fieldName}-template-field-${index}`}
      label={<h4>{fieldLabel}</h4>}
      displayWhenOpen={renderAccordionHeader()}
      displayWhenClosed={renderAccordionHeader()}
      closedByDefault={closedByDefault}
      separator={separator}
      open={open}
      onToggle={onToggle}
    >
      <div>{children}</div>
    </Accordion>
  );
}

FieldAccordion.propTypes = propTypes;

export default FieldAccordion;
